export const iconFontAwesomeMediaplaybackStop = (
	<i className="fa-solid fa-stop"></i>
);
